import { DotsSpinner } from '@flippingbook/web.react-kit/dist/DotsSpinner';

import logo from './assets/chat.svg';
import { useDriftLoader } from './provider';
import { b, e } from './style.css';

export function DriftLoaderButton() {
    const [state, openChat] = useDriftLoader();

    if (state === 'initial') {
        return (
            <div className={b.name}>
                <button
                    className={e.button}
                    onClick={openChat}
                >
                    <img
                        src={logo}
                        alt="Open chat"
                        width="24"
                        height="24"
                    />
                </button>
            </div>
        );
    }

    if (state === 'loading') {
        return (
            <div className={b.name}>
                <DotsSpinner />
            </div>
        );
    }

    return null;
}
